import { ActionTypes } from 'utils/constants';
import { getDeepProp } from 'utils/get-deep-prop';

const initialState = {};

export const login = (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.TOGGLE_LOGIN_MODAL: {
            if (state.modalOpen) {
                return {}; // reset state when modal is closed
            }
            
            return {
                ...state,
                modalOpen: true
            };
        }
        case ActionTypes.SET_LOGIN_FROM_JOIN: {
            return {
                ...state,
                fromJoin: true
            };
        }
        case ActionTypes.FORGOT_PASSWORD  + '_PENDING':
        case ActionTypes.LOGIN + '_PENDING': {
            return {
                ...state,
                processing: true,
                error: null,
                success: null
            };
        }
        case ActionTypes.FORGOT_PASSWORD  + '_REJECTED':
        case ActionTypes.LOGIN + '_REJECTED': {
            const error = getDeepProp(action, 'payload', 'response', 'data', 'msg');

            return {
                ...state,
                error,
                processing: false
            };
        }
        case ActionTypes.FORGOT_PASSWORD  + '_FULFILLED':
        case ActionTypes.LOGIN + '_FULFILLED': {
            return {
                ...state,
                processing: false,
                success: true,
                error: null
            };
        }
        default: {
            return state;
        }
    }
};
